import React from 'react'
import { router, usePage, Link } from '@inertiajs/react'
import {
  Box, Button, Table, TableBody, TableCell, TableContainer, TableHead,
  TableRow, Paper, Select, MenuItem, Chip, IconButton, Tooltip,
} from '@mui/material'
import PersonAddIcon from '@mui/icons-material/PersonAdd'
import BlockIcon from '@mui/icons-material/Block'
import AppShell from '../../../../components/layout/AppShell'
import PageHeader from '../../../../components/ui/PageHeader'

Index.layout = (page) => <AppShell>{page}</AppShell>

const ROLE_LABELS = {
  admin: 'Administrator',
  manager: 'Manager',
  accountant: 'Buchhalter',
  readonly: 'Nur Lesen',
}

export default function Index({ memberships = [], current_user_id }) {
  const { props } = usePage()
  const tenant = props.tenant || {}
  const basePath = `/m/${tenant.slug}/settings`

  const handleRoleChange = (membership, role) => {
    router.patch(`${basePath}/users/${membership.id}`, { tenant_user: { role } }, { preserveScroll: true })
  }

  const handleDeactivate = (membership) => {
    router.delete(`${basePath}/users/${membership.id}`, { preserveScroll: true })
  }

  return (
    <Box>
      <PageHeader
        title="Benutzer"
        breadcrumbs={[
          { label: 'Dashboard', href: `/m/${tenant.slug}` },
          { label: 'Einstellungen' },
          { label: 'Benutzer' },
        ]}
        actions={
          <Button
            component={Link}
            href={`${basePath}/invitations/new`}
            variant="contained"
            startIcon={<PersonAddIcon />}
            data-testid="invite-user-btn"
          >
            Benutzer einladen
          </Button>
        }
      />

      <TableContainer component={Paper} variant="outlined">
        <Table size="small">
          <TableHead>
            <TableRow sx={{ backgroundColor: '#F9FAFB' }}>
              <TableCell>Name</TableCell>
              <TableCell>E-Mail</TableCell>
              <TableCell>Rolle</TableCell>
              <TableCell>Status</TableCell>
              <TableCell align="right">Aktionen</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {memberships.length === 0 ? (
              <TableRow>
                <TableCell colSpan={5} align="center">Keine Benutzer.</TableCell>
              </TableRow>
            ) : (
              memberships.map((m) => (
                <TableRow key={m.id} data-testid={`membership-row-${m.id}`}>
                  <TableCell>{m.user.display_name || `${m.user.first_name || ''} ${m.user.last_name || ''}`.trim() || '—'}</TableCell>
                  <TableCell>{m.user.email}</TableCell>
                  <TableCell>
                    <Select
                      size="small"
                      value={m.role}
                      onChange={(e) => handleRoleChange(m, e.target.value)}
                      disabled={!m.active}
                      data-testid={`role-select-${m.id}`}
                      slotProps={{ htmlInput: { 'data-testid': `role-select-input-${m.id}` } }}
                    >
                      {Object.entries(ROLE_LABELS).map(([value, label]) => (
                        <MenuItem key={value} value={value}>{label}</MenuItem>
                      ))}
                    </Select>
                  </TableCell>
                  <TableCell>
                    {m.active ? (
                      <Chip label="Aktiv" size="small" color="success" />
                    ) : (
                      <Chip label="Deaktiviert" size="small" />
                    )}
                  </TableCell>
                  <TableCell align="right">
                    {m.active && m.user.id !== current_user_id && (
                      <Tooltip title="Benutzer deaktivieren">
                        <IconButton
                          size="small"
                          onClick={() => handleDeactivate(m)}
                          data-testid={`deactivate-btn-${m.id}`}
                        >
                          <BlockIcon fontSize="small" />
                        </IconButton>
                      </Tooltip>
                    )}
                  </TableCell>
                </TableRow>
              ))
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  )
}
